<!-- =========================================================================================


File Name: ECommerceCheckout.vue

Description: eCommerce Checkout page

----------------------------------------------------------------------------------------

========================================================================================== -->

<template>
  <div id="ecommerce-checkout-demo">
    <form-wizard
      ref="checkoutWizard"
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      :hide-buttons="true"
    >
      <!-- tab 1 content -->
      <tab-content title="Add order" icon="feather icon-shopping-cart">
        <!-- IF CART HAVE ITEMS -->

        <div>
          <vs-tabs v-model="activeTab" alignment="center">
            <vs-tab label="Enter order">
              <div class="vx-row">
                <!-- LEFT COL -->
                <div class="vx-col lg:w-2/3 w-full relative">
                  <div class="vx-row mb-4">
                    <div class="vx-col w-full lg:w-full">
                      <vs-input
                        style="width: 100%"
                        icon-no-border
                        placeholder="Search for parts..."
                        v-model="knowledgeBaseSearchQuery"
                        icon-pack="feather"
                        icon="icon-search"
                      />
                    </div>
                  </div>
                  <ul id="example-1">
                    <li
                      v-if="knowledgeBaseSearchQuery"
                      style="font-weight: bold"
                    >
                      <div style="width: 20%; display: inline-block">
                        Item name
                      </div>
                      <div style="width: 40%; display: inline-block">
                        Item description
                      </div>
                      <div style="width: 20%; display: inline-block">
                        Item Stock
                      </div>
                      <div style="width: 20%; display: inline-block">
                        Item photo
                      </div>
                    </li>
                    <li v-for="(item, i) in filteredKB" :key="i">
                      <div
                        :class="darkTheme ? 'searchItemDark' : 'searchItem'"
                        @click="addItem(item)"
                      >
                        <div style="width: 20%; display: inline-block">
                          {{ item.label }}:
                        </div>
                        <div style="width: 40%; display: inline-block">
                          {{ item.excerpt }}
                        </div>
                        <div style="width: 20%; display: inline-block;" :style="item.soh > 0 ? 'color:#008000':'color:#864545'">
                          {{ item.soh > 0 ? "In Stock":"" }}
                        </div>
                        <div style="width: 20%; display: inline-block">
                          <img
                            v-if="item.pictureSrc"
                            :src="item.pictureSrc"
                            width="100"
                            height="100"
                            class="imageThumbnail"
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div>
                    <b-table
                      striped
                      hover
                      :items="getCart"
                      :fields="fields"
                      :dark="darkTheme"
                    >
                      <template v-slot:cell(label)="row">
                        <span v-if="modifyParts">
                          <b-form-input v-model="row.item.label" />
                        </span>
                        <span v-else>
                          {{ row.item.label }}
                        </span>
                      </template>
                      <template v-slot:cell(excerpt)="row">
                        <span v-if="modifyParts">
                          <b-form-input v-model="row.item.excerpt" />
                        </span>
                        <span v-else>
                          {{ row.item.excerpt }}
                        </span>
                      </template>
                      <template v-slot:cell(item_qty)="row">
                        <b-form-input
                          v-model="row.item.item_qty"
                          type="number"
                        />
                      </template>
                      <template v-slot:cell(price)="row">
                        <span v-if="modifyParts">
                          <b-form-input
                            v-model="row.item.price"
                            type="number"
                          />
                        </span>
                        <span v-else>
                          {{ row.item.price.toFixed(2) }}
                        </span>
                      </template>
                      <template #cell(totalprice)="row">
                        {{
                          "$" + (row.item.price * row.item.item_qty).toFixed(2)
                        }}
                      </template>
                      <template #cell(soh)="row">
                        {{ row.item.soh }}
                      </template>
                      <template #cell(pictureSrc)="row">
                        <img
                          v-if="row.item.pictureSrc"
                          :src="row.item.pictureSrc"
                          width="100"
                          height="100"
                          class="imageThumbnail"
                        />
                      </template>
                      <template v-slot:cell(isAdded)="row">
                        <span
                          style="cursor: pointer"
                          @click="removeItem(row.item)"
                          >X</span
                        >
                      </template>
                    </b-table>
                  </div>
                  <div>
                    <p>
                      <span
                        style="cursor: pointer; font-weight: bold"
                        @click="addNewRow"
                        v-if="modifyParts"
                        >Add new row</span
                      >
                    </p>
                  </div>
                </div>

                <!-- RIGHT COL -->
                <div class="vx-col lg:w-1/3 w-full">
                  <vx-card>
                    <p class="font-semibold mb-3">Price details</p>
                    <div class="flex justify-between mb-2">
                      <span class="text-grey">Total price</span>
                      <span>${{ getSubTotal().toFixed(2) }}</span>
                    </div>

                    <vs-divider />

                    <vs-button
                      color="success"
                      class="w-full"
                      @click="confirmOrder()"
                      >Confirm Order</vs-button
                    >
                  </vx-card>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="Upload order" disabled>
              <div class="mt-4">
                <b-form-file
                  v-model="file"
                  :state="Boolean(file)"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @input="uploadFile()"
                ></b-form-file>
                <div class="mt-3">
                  Selected file: {{ file ? file.name : "" }}
                </div>
                <div v-if="uploading">
                  <div class="d-flex justify-content-center">
                    <b-progress
                      :value="progress"
                      :max="maxProgress"
                      show-progress
                      animated
                      style="width: 100%"
                    ></b-progress>
                  </div>
                  <div class="d-flex justify-content-center">
                    Status: {{ currentUploadStatus }}
                  </div>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>

        <!-- IF NO ITEMS IN CART -->
      </tab-content>
      <tab-content
        title="Order confirmation"
        icon="feather icon-shopping-cart"
        class="mb-5"
      >
        <template slot="actions">
          <feather-icon
            icon="PlusIcon"
            svgClasses="w-6 h-6 text-grey"
          ></feather-icon>
        </template>

        <!-- IF CART HAVE ITEMS -->
        <div class="vx-row">
          <div class="vx-col lg:w-2/3 w-full relative">
            <div class="vx-col w-full relative mt-3">
              <vs-table
                noDataText="No content available"
                pagination
                max-items="6"
                :data="cart"
              >
                <template slot="thead">
                  <vs-th sort-key="full_name">Product code</vs-th>

                  <vs-th sort-key="email">Quantity</vs-th>

                  <vs-th sort-key="mobile_phone">Unit Price</vs-th>

                  <vs-th>Total Price</vs-th>

                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.label }}</vs-td>

                    <vs-td>
                      {{ tr.item_qty }}
                    </vs-td>

                    <vs-td>{{ "$" + tr.price.toFixed(2) }}</vs-td>

                    <vs-td>{{
                      "$" + (tr.item_qty * tr.price).toFixed(2)
                    }}</vs-td>

                    <vs-td>
                      <div class="vx-row">
                        <vs-button
                          color="primary"
                          class="ml-1"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-trash"
                          @click="removeItem(tr)"
                        ></vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>

          <div class="vx-col lg:w-1/3 w-full">
            <div class="vx-row w-full mt-2">
              <vx-card>
                <p class="font-semibold mb-3">Customer Order No:</p>
                <vs-input 
                  v-model="customerOrder"
                  >
                </vs-input>
                <p class="font-semibold mb-3">Contact Name/No:</p>
                <vs-input
                  v-model="contactNumber"
                  >
                </vs-input>
                <p class="font-semibold mb-3">Notes:</p>
                <vs-textarea v-model="notes" rows="2"> </vs-textarea>
                <p class="font-semibold mb-3">Delivery Address:</p>
                <vs-textarea v-model="deliveryAddress" rows="4"> </vs-textarea>
              </vx-card>
            </div>
            <div class="vx-row w-full mt-2">
              <vx-card>
                <p class="font-semibold mb-3">Freight Options</p>

                <select v-model="deliveryMethod" v-if="deliveryOptions">
                  <option disabled value="">Please select one</option>
                  <option
                    v-for="option in deliveryOptions"
                    :value="option"
                    :key="option.label"
                  >
                    {{ option.label + " $" + option.price.toFixed(2) }}
                  </option>
                </select>
              </vx-card>
            </div>
            <div class="vx-row w-full mt-2">
              <vx-card>
                <p class="font-semibold mb-3">Price details</p>
                <div class="flex justify-between mb-2">
                  <span class="text-grey">SubTotal</span>
                  <span> ${{ getSubTotal().toFixed(2) }} </span>
                </div>

                <div class="flex justify-between mb-2">
                  <span class="text-grey">Tax</span>
                  <span>${{ getTotalTax().toFixed(2) }}</span>
                </div>

                <div class="flex justify-between mb-2">
                  <span class="text-grey">Delivery Charges</span>
                  <span>{{
                    this.deliveryMethod
                      ? "$" + this.deliveryMethod.price
                      : "TBC"
                  }}</span>
                </div>

                <vs-divider />

                <div class="flex justify-between font-semibold mb-3">
                  <span>Total</span>
                  <span> ${{ getTotalPrice().toFixed(2) }} </span>
                </div>

                <vs-button color="success" class="w-full" @click="submitOrder()"
                  >Place Order</vs-button
                >
              </vx-card>
            </div>
          </div>
        </div>
      </tab-content>

      <!-- tab 3 content -->
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

const ItemListView = () => import("./components/ItemListView.vue");

export default {
  data() {
    return {
      cartItems: [],
      cart: [],
      fields: [
        {
          key: "label",
          label: "Item",
        },
        {
          key: "excerpt",
          label: "Description",
        },
        {
          key: "item_qty",
          label: "Quantity",
        },
        {
          key: "price",
          label: "Unit Price",
        },
        {
          key: "totalprice",
          label: "Total",
        },
        {
          key: "soh",
          label: "Stock",
        },
        {
          key: "pictureSrc",
          label: "",
        },
        {
          key: "isAdded",
          label: "",
        },
      ],
      textarea: "",
      cartData: [],
      knowledgeBaseSearchQuery: "",
      activeTab: 0,
      file: null,
      progress: 0,
      maxProgress: 100,
      currentUploadStatus: "",
      uploading: false,
      username: "",
      email: "",
      deliveryAddress: "",
      notes:"",
      contactNumber:"",
      deliveryAddressCopy: "",
      customerOrder: "",
      deliveryName: "",
      deliveryPhone: "",
      modifyParts: "",
      lookupItemPrice: false,
      checkEnoughStock: true,
      companyEmail: "",
      darkTheme: false,
      deliveryMethod: null,
      deliveryOptions: [],
      minimumLineValue: 0,
      minimumOrderTotal: 0,
    };
  },
  computed: {
    filteredKB() {
      const maxResultsLength = 20;
      let lower = this.knowledgeBaseSearchQuery.toLowerCase();
      if (this.knowledgeBaseSearchQuery == "") {
        return [];
      } else {
        let res = this.cartItems.filter(
          (item) =>
            item.label.toLowerCase().includes(lower) ||
            item.excerpt.toLowerCase().includes(lower)
        );
        return res.slice(0, maxResultsLength);
      }
    },
    getCart() {
      return this.cart;
    },
  },
  created() {
    this.getParts();
    this.getUserDetailsAndSaveCopy();
  },
  methods: {
    async getUserDetailsAndSaveCopy() {
      await this.getUserDetails();
      this.deliveryAddressCopy = this.deliveryAddress + "";
    },
    async getParts() {
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/getParts"
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);

      const rawResponse = await fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
      });

      const response = await rawResponse.json();
      if (!this.encounteredErrors(response)) {
        this.cartItems = [];
        this.cart = [];
        response.list.forEach((item) => {
          if (item.customer_part.startsWith("DELIVERY_PART_")) {
            this.deliveryOptions.push({
              label: item.description,
              price: item.unit_price,
            });
          } else {
            this.cartItems.push({
              label: !item.customer_part ? "" : item.customer_part,
              price: !item.unit_price ? 0 : item.unit_price,
              item_qty: 1,
              excerpt: !item.description ? "" : item.description,
              pictureSrc: item.picture_url,
              isAdded: 0,
              isTaxed: item.tax == 1,
              part: item.part,
              soh:item.soh
            });
          }
        });
      }
    },
    addItem(item) {
      this.knowledgeBaseSearchQuery = "";
      if (!this.alreadyAdded(item)) {
        if (this.lookupItemPrice) {
          this.showLoadingSpinner();
          this.getPriceAndAddToCart(item);
        } else {
          item.soh = 0;
          this.cart.push(item);
        }
      } else {
        this.alertUser("danger", "Item already added to cart!");
      }
    },
    getPriceAndAddToCart(item) {
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/getMyPrice"
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
      urlWithParams.searchParams.append("part", item.part);

      const isUserCustomer = this.$store.getters.isUserCustomer;
      if (isUserCustomer) {
        urlWithParams.searchParams.append(
          "customer",
          this.$store.getters.userCustomer
        );
      }

      fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
      })
        .then((response) => response.json())
        .then((data) => {
          if (!this.encounteredErrors(data)) {
            item.price = data.sell_price;
            item.soh = data.soh;
            this.cart.push(item);
          }
          this.hideLoadingSpinner();
        });
    },
    notifyProgessBar(progressIncrement, status) {
      this.progress += progressIncrement;
      this.currentUploadStatus = status;
    },
    uploadFile() {
      if (this.file == null) return;

      this.progress = 0;
      this.currentUploadStatus = "";
      this.uploading = true;
      let fileToSend = this.file;
      let fn1 = this.waitForInvoiceToComplete;
      let fn2 = this.notifyProgessBar;
      let reader = new FileReader();

      reader.addEventListener("load", function () {
        let file = reader.result;

        let body = {
          PictureName: fileToSend.name,
          PictureStream: Array.from(new Uint8Array(file)),
        };

        const urlWithParams = new URL(
          process.env.VUE_APP_BASE_URL + "Rest/uploadCustomerInvoiceImage"
        );
        urlWithParams.searchParams.append(
          "APIKey",
          process.env.VUE_APP_API_KEY
        );

        fn2(25, "Uploading...");

        fetch(urlWithParams.href, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            if (!this.encounteredErrors(data)) {
              fn1(data);
            }
          });
      });

      reader.readAsArrayBuffer(fileToSend);
    },
    async waitForInvoiceToComplete(response) {
      this.notifyProgessBar(25, "Processing...");
      let invoiceId = response.invoice_id;

      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/workflowStatus"
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
      urlWithParams.searchParams.append("invoiceid", invoiceId);

      /*eslint no-constant-condition: ["error", { "checkLoops": false }]*/
      // wait until invoice is complete
      while (true) {
        const rawResponse = await fetch(urlWithParams.href, {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        let rawJson = await rawResponse.json();
        if (!this.encounteredErrors(rawJson)) {
          let isComplete = rawJson.complete;
          if (isComplete) {
            break;
          }

          // sleep for a second
          await new Promise((r) => setTimeout(r, 1000));
        } else {
          break;
        }
      }

      // now request data from ezzybills
      this.getInvoiceData(invoiceId);
    },
    getInvoiceData(invoiceId) {
      this.notifyProgessBar(25, "Getting invoice rows...");
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/getInvoiceRows"
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
      urlWithParams.searchParams.append("invoiceid", invoiceId);

      fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (!this.encounteredErrors(data)) {
            this.getRows(data);
          }
        });
    },
    getRows(rowData) {
      this.notifyProgessBar(15, "Entering invoice rows...");
      rowData.rows.forEach((item) => {
        let rowDict = {};
        item.columns.forEach((cell) => (rowDict[cell.column] = cell.data));
        this.cart.push({
          label: this.getCellSafe("Supplier Article Code", rowDict),
          price: this.getCellFloatSafe("Unit Price", rowDict),
          item_qty: this.getCellIntSafe("Quantity", rowDict),
          excerpt: this.getCellSafe("Description", rowDict),
          isAdded: 1,
        });
      });
      this.notifyProgessBar(10, "Complete!");
      this.switchToTableView();
      this.hideLoadingSpinner();
    },
    switchToTableView() {
      this.activeTab = 0;
    },
    getCellSafe(label, cells) {
      if (cells[label] == undefined) {
        return "";
      } else {
        return cells[label];
      }
    },
    getCellIntSafe(label, cells) {
      let result = this.getCellSafe(label, cells);
      if (result == "") {
        return 0;
      } else {
        return parseInt(result);
      }
    },
    getCellFloatSafe(label, cells) {
      let result = this.getCellSafe(label, cells);
      if (result == "") {
        return 0.0;
      } else {
        return parseFloat(result);
      }
    },
    getSubTotal() {
      return this.cart.reduce(
        (accumulator, current) =>
          accumulator + current.price * current.item_qty,
        0
      );
    },
    getTotalPrice() {
      try {
        let sum = this.getSubTotal();
        sum += this.getTotalTax();
        if (this.deliveryMethod) sum += this.deliveryMethod.price;
        return sum;
      } catch (err) {
        return 0;
      }
    },
    submitOrder() {
      if (this.cart.length === 0) {
        this.alertUser("danger", "Please add items to your cart");
        return;
      }

      // if (this.deliveryAddress == "") {
      //   this.alertUser("danger", "You need to supply a valid delivery address");
      //   return;
      // }

      if (this.checkMinimumRowValuesAndInvoiceAmount()) {
        this.alertUser("danger", this.checkMinimumRowValuesAndInvoiceAmount());
        return;
      }

      // if (!this.deliveryMethod) {
      //   this.alertUser("danger", "Please select a delivery method");
      //   return;
      // }

      if (
        this.deliveryAddress != this.deliveryAddressCopy &&
        this.$store.getters.userRole.includes("Customer")
      ) {
        this.saveNewDeliveryAddress().then((data) => {
          if (data.status === 200) {
            this.uploadPurchaseOrder();
          }
        });
      } else {
        this.uploadPurchaseOrder();
      }
    },
    uploadPurchaseOrder() {
      this.showLoadingSpinner();

      const isUserCustomer = this.$store.getters.isUserCustomer;
      let endPoint = "";

      if (isUserCustomer) {
        endPoint = "Rest/uploadMyCustomersCustomerInvoiceImage";
      } else {
        endPoint = "Rest/uploadCustomerInvoiceImage";
      }

      const urlWithParams = new URL(
        `${process.env.VUE_APP_BASE_URL}${endPoint}`
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);

      let data = {
        Name: this.username,
        // TaxNumber: "",
        Email: this.email,
        Phone: this.contactNumber,
        address: this.deliveryAddress,
        // Number: "Invoice",
        Reference: this.customerOrder,
        Date: this.getDateString(),
        Notes: this.notes,
        DeliveryMethod: this.deliveryMethod !== null ? this.deliveryMethod.label : "",
        DeliveryCharge: this.deliveryMethod !== null ? this.deliveryMethod.price : 0,
        Total: this.getTotalPrice(),
        Tax: this.getTotalTax(),
        Lines: this.getLines(),
      };
      const raw = JSON.stringify(data);

      const body = {
        ...(isUserCustomer
          ? { CustomerName: this.$store.getters.userCustomer }
          : {}),
        PictureName: "order.json",
        PictureStream: this.getByteArray(raw),
      };

      fetch(urlWithParams.href, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          if (!this.encounteredErrors(data)) {
            this.hideLoadingSpinner();
            this.$router.push("/orders");
            this.alertUser("success", "Order has been placed!");
          } else {
            this.hideLoadingSpinner();
          }
        });
    },
    saveNewDeliveryAddress() {
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/saveCustomerSettings"
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);

      let newSettings = {
        email: this.email,
        delivery_address: this.deliveryAddress,
        contact_name: this.deliveryName,
        contact_phone: this.deliveryPhone,
      };

      return fetch(urlWithParams.href, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newSettings),
      });
    },
    getLines() {
      const GST_PERCENT = 0.1;
      let lines = [];
      this.cart.forEach((item) =>
        lines.push({
          Code: item.part,
          Number: "",
          Description: item.excerpt,
          Quantity: item.item_qty,
          UnitPrice: item.price,
          Tax: (item.price * item.item_qty * GST_PERCENT).toFixed(2),
          Total: (item.item_qty * item.price * (1 + GST_PERCENT)).toFixed(2),
        })
      );
      return lines;
    },
    getByteArray(str) {
      let encoder = new TextEncoder();
      let encoded = encoder.encode(str);
      return Array.from(encoded);
    },
    addNewRow() {
      this.cart.push({
        label: "",
        price: 0,
        item_qty: 0,
        excerpt: "",
        isAdded: 0,
        soh: 0,
        isTaxed: false,
        part: "",
      });
    },
    removeItem(item) {
      let index = this.cart.indexOf(item);
      this.cart.splice(index, 1);
    },
    confirmOrder() {
      if (this.cart.length == 0) {
        this.alertUser("danger", "Please add items to your cart");
      } else if (this.checkItemQuantities()) {
        this.alertUser("danger", this.checkItemQuantities());
      } else {
        if (this.checkEnoughStock && this.notEnoughStock()) {
          this.alertUser("danger", this.notEnoughStock(), 20000);
        } else {
          this.roundQuantities();
          this.$refs.checkoutWizard.nextTab();
        }
      }
    },
    notEnoughStock() {
      for (let i = 0; i < this.cart.length; i++) {
        let item = this.cart[i];
        if (item.item_qty > item.soh) {
          if (item.soh == 0) {
            return `${item.label} is out of stock! Please contact ${this.companyEmail} for backorder requests.`;
          } else {
            return `${item.label} only has ${item.soh} stock! Please contact ${this.companyEmail} for backorder requests.`;
          }
        }
      }
      return false;
    },
    checkItemQuantities() {
      for (let i = 0; i < this.cart.length; i++) {
        let item = this.cart[i];
        if (item.item_qty < 1) {
          return "Your quantity must be at least 1";
        }
      }
      return false;
    },
    roundQuantities() {
      for (let i = 0; i < this.cart.length; i++) {
        let item = this.cart[i];
        item.item_qty = Math.floor(item.item_qty);
      }
    },
    getTotalTax() {
      let tax = 0;
      // 10%
      const GST_PERCENT = 0.1;
      for (let i = 0; i < this.cart.length; i++) {
        let item = this.cart[i];
        // if (item.isTaxed) tax += item.price * item.item_qty * GST_PERCENT;
        tax += item.price * item.item_qty * GST_PERCENT;
      }
      if(this.deliveryMethod)
      tax += this.deliveryMethod.price * GST_PERCENT;
      return tax;
    },
    alreadyAdded(itemToAdd) {
      for (let i = 0; i < this.cart.length; i++) {
        let item = this.cart[i];
        if (
          item.label === itemToAdd.label &&
          item.excerpt === itemToAdd.excerpt
        )
          return true;
      }
      return false;
    },
    checkMinimumRowValuesAndInvoiceAmount() {
      let sum = 0;
      for (let i = 0; i < this.cart.length; i++) {
        let item = this.cart[i];
        let cost = item.item_qty * item.price;
        if (cost < this.minimumLineValue)
          return (
            "Each item must have a minimum value of $" +
            this.minimumLineValue.toFixed(2)
          );
        sum += cost;
      }
      if (sum < this.minimumOrderTotal) {
        return (
          "Your order must have a minimum value of $" +
          this.minimumOrderTotal.toFixed(2)
        );
      }
    },
    getFreightDetails() {
      return this.deliveryMethod
        ? `{'Delivery Method': '${this.deliveryMethod.label}','Cost': ${this.deliveryMethod.price}}`
        : `{'Delivery Method': 'Not Selected' ,'Cost': 0}`;
    },
  },
  components: {
    ItemListView,
    FormWizard,
    TabContent,
  },
};
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    .search-location {
      color: inherit;
      position: relative;
      padding: 0.7rem;
      border-radius: 5px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
      width: 100%;
      font-size: 1rem !important;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
      }
    }
  }
}

.imageThumbnail {
  border: 0px;
  border-radius: 20px;
}

.searchItem {
  cursor: pointer;
  font-weight: bold;
  padding: 5px;
  border-bottom: 1px solid grey;
}

.searchItem:hover {
  background-color: lightgrey;
}

.searchItemDark {
  cursor: pointer;
  font-weight: bold;
  padding: 5px;
  border-bottom: 1px solid grey;
}

.searchItemDark:hover {
  background-color: lightgrey;
  color: black;
}
</style>
